import Icon, {LogoutOutlined, ReloadOutlined} from '@ant-design/icons';
import {Layout, Menu} from 'antd';

import {useLogOut} from 'pm-auth';
import {Download, PieChart, Squares, Cog, Coin} from 'pm-icons';
import {useLocation, useNavigate} from 'react-router-dom';

const {Sider} = Layout;

type SideMenuProps = {
    menuCollapsed: boolean;
}

const pathToKey: Record<string, string> = {
    '/auth/expenses':           'Expenses',
    '/auth/recurring-expenses': 'Recurring Expenses',
    '/auth/analytics':          'Analytics',
    '/auth/categories':         'Categories',
    '/auth/export':             'Export',
    '/auth/settings':           'Settings',
}

export function SideMenu({menuCollapsed}: Readonly<SideMenuProps>) {
    const logOut = useLogOut()
    const navigate = useNavigate()
    const {pathname} = useLocation();
    const selectedKey = pathToKey[pathname];

    return (
        <Sider
            className={'side-menu'}
            trigger={null}
            collapsible={true}
            collapsed={menuCollapsed}
            collapsedWidth={0}
        >
            <Menu
                mode={'inline'}
                theme={'dark'}
                selectedKeys={[selectedKey]}
                items={[
                    {
                        key:     'Expenses',
                        label:   'Expenses',
                        icon:    <Icon component={Coin}/>,
                        onClick: () => navigate('/auth/expenses'),
                    },
                    {
                        key:     'Recurring Expenses',
                        label:   'Recurring Expenses',
                        icon:    <ReloadOutlined/>,
                        onClick: () => navigate('/auth/recurring-expenses'),
                    },
                    {
                        key:   'Analytics',
                        label: 'Analytics',
                        icon:  <Icon component={PieChart}/>,
                        onClick: () => navigate('/auth/analytics'),
                    },
                    {
                        key:   'Categories',
                        label: 'Categories (soon)',
                        icon:  <Icon component={Squares}/>,
                    },
                    {
                        key:   'Export',
                        label: 'Export (soon)',
                        icon:  <Icon component={Download}/>,
                    },
                    {
                        key:   'Settings',
                        label: 'Settings (soon)',
                        icon:  <Icon component={Cog}/>,
                    },
                ]}
            />

            <Menu
                mode={'inline'}
                theme={'dark'}
                items={[
                    {
                        key:     'Log out',
                        label:   'Log out',
                        icon:    <LogoutOutlined/>,
                        onClick: logOut,
                    },
                ]}
            />
        </Sider>
    )
}
